import LabRepository from "./LabRepository";

const resource = "/process-schedule";
const additional_resource = "-instrument-instance";

export default {
  addSample(id, payload) {
    return LabRepository.post(
      `${resource}/${id}/instrument-instance-schedules`,
      {
        instrument_instance_schedules: payload
      }
    );
  },
  syncSamples(id, payload) {
    return LabRepository.put(
      `${resource}/${id}/instrument-instance-schedules`,
      {
        instrument_instance_schedules: payload
      }
    );
  },
  deleteSample(id, payload) {
    return LabRepository.delete(
      `${resource}/${id}/instrument-instance-schedules`,
      {
        data: { instrument_instance_schedules: payload }
      }
    );
  },
  updateJig(id, payload) {
    return LabRepository.put(`${resource}${additional_resource}/${id}`, {
      instrument_jig_id: payload
    });
  }
};
